import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Intercom from '@intercom/messenger-js-sdk';

export function IntercomChat({ user }) {
    const location = useLocation();

    // Check if we're on the survey creation/edit page (not analytics, logic, integrate, etc.)
    const isSurveyDesignerPage = /^\/survey\/[^/]+$/.test(location.pathname);
    // Hide the launcher entirely on the survey designer page (all devices) so it
    // doesn't overlap the design canvas / controls.
    const shouldHideLauncher = isSurveyDesignerPage;

    // Initialize Intercom once
    useEffect(() => {
        if (user) {
            Intercom({
                app_id: process.env.REACT_APP_INTERCOM_APP_ID,
                user_id: user.uid,
                name: user.displayName || 'Anonymous',
                email: user.email,
                created_at: Math.floor(user.metadata.creationTime / 1000), // Convert to Unix timestamp
            });
        } else {
            Intercom({
                app_id: process.env.REACT_APP_INTERCOM_APP_ID,
            });
        }

        // Cleanup on unmount
        return () => {
            if (window.Intercom) {
                window.Intercom('shutdown');
            }
        };
    }, [user]); // Re-run when user changes

    // Hide/show Intercom launcher: hidden on the survey designer page.
    useEffect(() => {
        if (window.Intercom) {
            window.Intercom('update', { hide_default_launcher: shouldHideLauncher });
        }
    }, [shouldHideLauncher]);

    return null;
} 